<ng-container *ngIf="product$ | async as product">
  <div
    class="cx-product-card"
    [ngClass]="{
      'cx-product-card-selected': isProductCardSelected()
    }"
    [attr.aria-label]="
      'configurator.a11y.itemOfAttribute'
        | cxTranslate
          : {
              attribute: productCardOptions.attributeLabel
            }
    "
  >
    <div class="cx-product-card-rows">
      <div class="cx-product-card-imgs">
        <cx-media
          [container]="product.images?.PRIMARY"
          format="product"
          aria-hidden="true"
        ></cx-media>
      </div>

      <div class="cx-product-card-info">
        <div class="cx-product-card-name">
          <p>
            {{ product.name }}
          </p>
        </div>
        <div class="cx-product-card-code" *ngIf="product.code">
          {{ 'configurator.attribute.id' | cxTranslate }}:
          {{ product.code }}
        </div>

        lm-configurator-show-more
      </div>
    </div>

    <div
      class="cx-product-card-rows column"
      *ngIf="!productCardOptions.singleDropdown || hasPriceDisplay()"
    >
      <div class="cx-product-card-quantity-price">
        <div class="cx-product-card-quantity">
          <cx-configurator-attribute-quantity
            *ngIf="showQuantity"
            (changeQuantity)="onChangeQuantity($event)"
            [quantityOptions]="extractQuantityParameters()"
          ></cx-configurator-attribute-quantity>
        </div>
        <div class="cx-product-card-price">
          <cx-configurator-price
            [formula]="extractPriceFormulaParameters()"
          ></cx-configurator-price>
        </div>
      </div>
      <div class="cx-product-card-action">
        <div
          class="cx-product-card-action-btn"
          *ngIf="!productCardOptions?.singleDropdown"
        >
          <ng-container *ngIf="productCardOptions?.multiSelect; else single">
            <button
              *ngIf="
                productCardOptions?.productBoundValue?.selected;
                else select
              "
              class="btn btn-secondary"
              (click)="onHandleDeselect()"
              [cxFocus]="focusConfig"
              [attr.aria-label]="getAriaLabelMultiSelected(product)"
              [attr.aria-describedby]="
                createAttributeUiKey('label', attributeName)
              "
            >
              {{ 'configurator.button.remove' | cxTranslate }}
            </button>

            <ng-template #select>
              <button
                class="btn btn-primary"
                (click)="onHandleSelect()"
                [disabled]="
                  productCardOptions.disableAllButtons || (loading$ | async)
                "
                [cxFocus]="focusConfig"
                [attr.aria-label]="getAriaLabelMultiUnselected(product)"
                [attr.aria-describedby]="
                  createAttributeUiKey('label', attributeName)
                "
              >
                {{ 'configurator.button.add' | cxTranslate }}
              </button>
            </ng-template>
          </ng-container>

          <ng-template #single>
            <button
              class="btn btn-primary"
              (click)="onHandleSelect()"
              [disabled]="
                productCardOptions.disableAllButtons || (loading$ | async)
              "
              *ngIf="
                !productCardOptions?.productBoundValue?.selected;
                else deselect
              "
              [cxFocus]="focusConfig"
              [attr.aria-label]="getAriaLabelSingleUnselected(product)"
              [attr.aria-describedby]="
                createAttributeUiKey('label', attributeName)
              "
            >
              {{ 'configurator.button.select' | cxTranslate }}
            </button>
            <ng-template #deselect>
              <ng-container
                *ngIf="
                  isValueCodeDefined(
                    productCardOptions?.productBoundValue?.valueCode
                  )
                "
              >
                <button
                  *ngIf="!productCardOptions?.hideRemoveButton"
                  class="btn btn-secondary"
                  (click)="onHandleDeselect()"
                  [disabled]="
                    productCardOptions.hideRemoveButton || (loading$ | async)
                  "
                  [cxFocus]="focusConfig"
                  [attr.aria-label]="getAriaLabelSingleSelected(product)"
                  [attr.aria-describedby]="
                    createAttributeUiKey('label', attributeName)
                  "
                >
                  {{ 'configurator.button.deselect' | cxTranslate }}
                </button>
                <span
                  *ngIf="productCardOptions?.hideRemoveButton"
                  class="cx-visually-hidden"
                  tabindex="0"
                >
                  {{ getAriaLabelSingleSelectedNoButton(product) }}
                </span>
              </ng-container>
            </ng-template>
          </ng-template>
        </div>
      </div>
    </div>
    <ng-container *ngIf="showDeselectionNotPossible">
      <div
        class="cx-product-card-rows deselection-error-message"
        aria-live="assertive"
        aria-atomic="true"
        role="alert"
        id="{{ createAttributeUiKey('attribute-msg', attributeName) }}"
      >
        <cx-icon class="deselection-error-symbol" type="ERROR"></cx-icon>
        {{ 'configurator.attribute.deselectionNotPossible' | cxTranslate }}
      </div>
    </ng-container>
  </div>
</ng-container>
